<script lang="ts">
import type { StudyChoroplethSlideProps } from '$lib/components/study/slide-layout-types'
import ChoroplethChart from '../charts/ChoroplethChart.svelte'
import StudySlide from '../StudySlide.svelte'
import StudySlideContent from '../StudySlideContent.svelte'

/** US choropleth geographic slide (`s4b`-style). `headlineHtml` is trusted `{@html}`. */
let props: StudyChoroplethSlideProps = $props()

const hlStyle = props.headlineStyle ?? 'margin-bottom:.7rem;'
</script>

<StudySlide
  id={props.id}
  active={props.active}
  extraBottom={props.extraBottom}
  background={props.background}
  slideClass={props.slideClass}
>
  <StudySlideContent
    maxWidth={props.maxWidth ?? '1020px'}
    contentClass={props.contentClass}
    style={props.contentStyle}
  >
    <div class="ey">{@html props.eyebrow}</div>
    <div class="hl" style={hlStyle}>{@html props.headlineHtml}</div>
    <div class="study-s4b-choro-shell">
      <ChoroplethChart
        stateData={props.stateData}
        divergingScale={props.divergingScale}
        topStates={props.topStates}
        chartTitle={props.chartTitle}
        chartSubtitle={props.chartSubtitle}
        calloutText={props.calloutText}
      />
    </div>
  </StudySlideContent>
</StudySlide>
